<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<!-- There is data -->
	<div class="row">
		<div class="col-12">
			<h2>Liste des sociétés</h2>
		</div>
	</div>

	<ng-template [ngIf]="hasEmptyList()">
		<!-- No data -->
		<div class="row">
			<div class="col-12">
				<p>Aucune société enregistrée.</p>
				<br><br>
			</div>
		</div>
	</ng-template>

	<ng-template [ngIf]="!hasEmptyList()">
		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prev()" [disabled]="isFirstPage()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="reset()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="next()" [disabled]="isLastPage()" styleClass="p-button-text"></p-button>
		</div>
		<p-table [value]="datas"
			[columns]="columns"
			sortField="name"
			[paginator]="true"
			[rows]="rows"
			[showCurrentPageReport]="true"
			[(first)]="first"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} société(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-datatable-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.sort"></p-sortIcon>
					</th>
					<th>Actions</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-column-filter">
					</th>
					<th>
						<p-dropdown [options]="stateChoice" appendTo="body" (onChange)="dt.filter($event.value, 'active', 'equals')" styleClass="p-column-filter" placeholder="Choix de l'état" [showClear]="true">
							<ng-template let-option pTemplate="item">
								<span [class]="'customer-badge status-'+option.value">{{option.label}}</span>
							</ng-template>
						</p-dropdown>
					</th>
					<th>&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-company let-companies="datas">
				<tr class="table-body-lines">
					<td>
						<a routerLink="/company-detail/{{company['_id']}}"> {{company["name"]}}</a>
					</td>
					<td>
						<span class="ls-state-active" *ngIf="company['active']">Active</span>
						<span class="ls-state-inactive" *ngIf="!company['active']">Désactivée</span>
					</td>
					<td>
						<button matTooltip="Editer" class="btn btn-primary material-item" type="button" mat-raised-button (click)="doRename(company['name'], company._id)"><i class="material-icons md-24 icons">edit</i></button>
						&nbsp;
						<button [disabled]="company['active']" matTooltip="Activer la société" class="btn btn-success material-item" type="button" mat-raised-button (click)="doActivate(company._id)"><i class="material-icons md-24 icons">power</i></button>
						&nbsp;
						<button [disabled]="!company['active']"matTooltip="Désactiver la société" class="btn btn-danger material-item" type="button" mat-raised-button (click)="doDeactivate(company._id)"><i class="material-icons md-24 icons">power_off</i></button>
					</td>
				</tr>
			</ng-template>
		</p-table>
	</ng-template>
	<br>

	<div class="row">
		<div class="col-12">
			<button type="button" class="btn btn-primary material-item" (click)="doAdd()"><i class="material-icons md-24 icons">add_box</i> Ajouter ...</button>
			<br><br>
		</div>
	</div>
</div>
